"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log1pDependencies = void 0;
var _dependenciesComplexClassGenerated = require("./dependenciesComplexClass.generated.js");
var _dependenciesDivideScalarGenerated = require("./dependenciesDivideScalar.generated.js");
var _dependenciesLogGenerated = require("./dependenciesLog.generated.js");
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var log1pDependencies = exports.log1pDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated.ComplexDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated.divideScalarDependencies,
  logDependencies: _dependenciesLogGenerated.logDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createLog1p: _factoriesAny.createLog1p
};